import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

import type { NotificationType } from './Notifications'

export const WrapContainerStyled = styled('div')`
  background-color: ${theme.colors.neutral.white};
  width: 360px;
  height: auto;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  top: 55px;
  right: 20px;
  position: absolute;
  background-color: ${theme.colors.neutral.white};
  z-index: 1000;
  box-shadow: ${theme.effects.boxShadow['rule-01']};
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  border: ${theme.shapes.borderWidth.thin} ${theme.colors.neutral.clear};
  border-radius: ${theme.shapes.borderRadius.sm};
`
export const Title = styled('div')`
  height: 45px;
  padding: ${theme.spacing.md} ${theme.spacing.xm};
  font-size: ${theme.typography.sizes.xs};
  font-weight: ${theme.typography.weight.lg};
  font-family: ${theme.typography.family.primary};
  color: ${theme.colors.neutral.black};
  border-bottom: ${theme.shapes.borderWidth.thin} ${theme.colors.neutral[100]};
`
export const Content = styled('div')`
  padding: ${theme.spacing.xm};
  font-size: ${theme.typography.sizes['2xs']};
  font-weight: ${theme.typography.weight.xsm};
  font-family: ${theme.typography.family.primary};
  color: ${theme.colors.neutral.medium};
`

export const NotificationsList = styled('div')`
  display: flex;
  flex-direction: column;
  max-height: 400px;
  overflow-y: auto;

  ::-webkit-scrollbar-thumb {
    background: ${theme.colors.neutral.light};
  }
`

export const NotificationContainer = styled('div')`
  padding: ${theme.spacing.md} ${theme.spacing.xm};
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.sm};
  border-bottom: ${theme.shapes.borderWidth.thin} ${theme.colors.neutral[100]};

  ${({ hasNotes }: { hasNotes: boolean }) =>
    hasNotes &&
    css`
      :hover {
        background-color: ${theme.colors.neutral[100]};
        cursor: pointer;
      }
    `}
`

export const Empty = styled('div')`
  padding: ${theme.spacing.xm};
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.sm};
  border-bottom: ${theme.shapes.borderWidth.thin} ${theme.colors.neutral[100]};
`
export const NotificationRow = styled('div')`
  display: flex;
  flex-direction: row;
  gap: ${theme.spacing.sm};
`
interface IconBoxProps {
  type: NotificationType
  read: boolean
}
const bgColor = (type: IconBoxProps['type']) => {
  const bgs = {
    error: '#FFF4F3',
    fail: '#FFF4F3',
    information: theme.colors.quartenary,
    success: 'rgba(122, 228, 89, 0.1)',
    warning: theme.colors.alert.warning[10],
  }
  return bgs[type]
}
export const IconBox = styled('div')<IconBoxProps>`
  width: 30px;
  height: 30px;
  border-radius: ${theme.shapes.borderRadius.full};
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ type }) => bgColor(type)};
  position: relative;
  ${({ read }) =>
    read &&
    css`
      &::after {
        content: ' ';
        width: ${theme.spacing.sm};
        height: ${theme.spacing.sm};
        background-color: ${theme.colors.alert.info.dark};
        border-radius: ${theme.shapes.borderRadius.full};
        border: ${theme.shapes.borderWidth.thin} ${theme.colors.neutral.white};
        position: absolute;
        top: 0;
        left: 0;
      }
    `}
`
export const NotificationTitleRow = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`
export const TitleContainer = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-grow: 1;
  gap: ${theme.spacing.xs};
`
export const TitleNotif = styled('span')`
  display: block;
  font-size: ${theme.typography.sizes['2xs']};
  font-weight: ${theme.typography.weight.md};
  font-family: ${theme.typography.family.primary};
  color: ${theme.colors.neutral.high};
`
export const SubTitleNotif = styled('span')`
  display: block;
  font-size: ${theme.typography.sizes['3xs']};
  font-weight: ${theme.typography.weight.xsm};
  font-family: ${theme.typography.family.primary};
  color: ${theme.colors.neutral.light};
`
export const ContentNotif = styled('p')`
  display: block;
  margin: 0;
  font-size: 11px;
  font-weight: ${theme.typography.weight.xsm};
  font-family: ${theme.typography.family.primary};
  color: ${theme.colors.neutral.medium};
  overflow: hidden;
  text-overflow: ellipsis;
`
